<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showHeader="false"
    :showPadding="false"
    :showLeftPadding="pattern.showLeftPadding"
    :showRightPadding="pattern.showRightPadding"
    :showTopPadding="pattern.showTopPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showBorderRadius="pattern.showBorderRadius"
    :boxType="pattern.boxType"
    :backgroundColor="pattern.backgroundColor"
  >
    <div slot="content" class="d-flex flex-row">
      <!-- 标题栏和状态栏占位符 -->
      <van-image
        lazy-load
        :src="data[0].src"
        class="flex-1"
        :class="{'img-radius':pattern.showImgBorderRadius}"
        mode="widthFix"
        @click="navToDetailPage(data[0],0)"
      />
      <div :class="{width:pattern.showSpace}"></div>
      <van-image
        lazy-load
        :src="data[1].src"
        class="flex-1"
        :class="{'img-radius':pattern.showImgBorderRadius}"
        mode="widthFix"
        @click="navToDetailPage(data[1],1)"
      />
    </div>
  </m-base>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => { }
    },
    data: {
      type: Array,
      default: () => [{
        src: '',
        navTo: ''
      },
      {
        src: '',
        navTo: ''
      }
      ]
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showBorderRadius: false,
          showLeftPadding: true,
          showRightPadding: true,
          showTopPadding: true,
          showBottomPadding: true,
          showSpace: true,
          showImgBorderRadius: false,
          boxType: 'block',
          backgroundColor: 'rgba(255,255,255,1)',
        }
      }
    },
  },
  data () {
    return {

    };
  },
  methods: {
    navToDetailPage (item, index) {
      let navTo = item.navTo
      if (navTo) {
        if (navTo.indexOf('http') > -1) {
          window.location.href = navTo
        } else {
          this.$router.push(this.$uitl.getPathQuery(navTo))
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
img {
  display: block;
}

.width {
  width: 10px;
}
.img-radius {
  border-radius: 12px;
  overflow: hidden;
}
</style>
